module.exports = __webpack_public_path__ + "static/media/matematyka.782bf820.svg";